<template>
  <b-modal
    ref="companySelectionModal"
    id="companySelectionModal"
    modal-class="company-selection-modal"
    size="md"
    backdrop="static"
    centered
    hide-header
    @hidden="resetState"
  >
    <div class="confirmation-content d-flex flex-column align-items-center">
      <p class="text-center" style="font-weight: bold; font-size: 16px;">
        スカウト希望する企業へのキャリア登録が必要です
      </p>
      <p class="text-center" style="font-weight: bold; font-size: 16px;">
        登録企業として選択してください
      </p>
      
      <div class="company-selection mt-4">
        <div class="form-check">
          <input 
            class="form-check-input" 
            type="checkbox" 
            id="companyCheckbox"
            v-model="selectedCompany"
          />
          <span class="form-check-label ml-3 company-name-text mt-2">
            {{ companyName }}
          </span>
          <span class="ml-2 desc-toggle" @click="toggleDesc" style="cursor: pointer;">
            <i class="fa fa-sort-down" aria-hidden="true" style="position: relative; top: -3px"></i>
          </span>
        </div>
        <div class="desc-wrapper mt-2">
          <div class="desc-scroll" v-show="isDescVisible">
            <div v-html="companyDescription" class="desc-content"></div>
            <!-- <div v-else class="text-muted" style="font-size: 12px;">説明はありません</div> -->
          </div>
        </div>
      </div>
    </div>
    
    <template #modal-footer>
      <div class="d-flex w-100" style="justify-content: space-around">
        <b-button 
          class="scout-button" 
          @click="handleProceed"
          :disabled="!selectedCompany || loading"
        >
          <span v-if="loading">送信中...</span>
          <span v-else>スカウト希望に進む</span>
        </b-button>
        <b-button 
          class="next-button" 
          @click="$emit('cancel')"
          :disabled="loading"
        >キャンセル</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "CompanySelectionModal",
  props: {
    companyName: {
      type: String,
      required: true
    },
    companyId: {
      type: [String, Number],
      required: false,
      default: ''
    },
    companyDescription: {
      type: String,
      required: false,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedCompany: false,
      isDescVisible: false
    };
  },
  methods: {
    show() {
      this.$refs.companySelectionModal.show();
    },
    hide() {
      this.$refs.companySelectionModal.hide();
    },
    resetState() {
      this.selectedCompany = false;
      this.isDescVisible = false;
    },
    toggleDesc() {
      this.isDescVisible = !this.isDescVisible;
    },
    handleProceed() {
      if (this.selectedCompany) {
        this.$emit('proceed');
      }
    }
  },
  computed: {}
};
</script>

<style scoped>
>>> .company-selection-modal .modal-footer {
  background: #ffffff !important;
  border-top: none !important;
}

>>> .company-selection-modal .confirmation-content {
  padding: 50px 10px;
}

.company-selection {
  width: 100%;
  max-width: 400px;
}

.form-check {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  /* border: 1px solid #e0e0e0; */
  border-radius: 8px;
  /* background-color: #f8f9fa; */
}

.form-check-input {
  width: 20px;
  height: 20px;
}

.form-check-label {
  font-size: 16px;
  font-weight: 500;
  margin: 0;
}

.desc-content {
  color: #3c3c3c;
  font-size: 14px;
}

/* Prevent modal height from changing on toggle */
.desc-wrapper {
  height: 110px; /* reserve space so modal height stays constant */
  overflow: hidden;
}

.desc-scroll {
  height: 100%;
  overflow-y: auto;
  padding-top: 8px;
}

.scout-button {
  background-color: #4F46E5 !important;
  border-color: #4F46E5 !important;
  color: white !important;
}

.next-button {
  background-color: #666666 !important;
  border-color: #666666 !important;
  color: white !important;
}

/* Mobile responsive styles for button container */
@media (max-width: 768px) {
  .d-flex.w-100 {
    flex-direction: column !important;
    gap: 10px;
    align-items:center !important;
    justify-content:center !important;
  }
  
  .scout-button,
  .next-button {
    width: 318px !important;
    height: 53px;
  }
}
</style> 